import http from '../http'

export function ups()
{
  return http.get('api/ups')
}

// 下单
export function order(data)
{
  return http.post('ups/order', data)
}

// 取消订单
export function cancel(code)
{
  return http.post('ups/cancel', { code })
}

// 下载Label
export function label(code) {
  return '/api/ups/label?code=' + code
}

// 查询价格
export function query(data)
{
  return http.post('api/ups/weight', data)
}

// 取件
export function pickup(data)
{
  return http.post('ups/pickup', data)
}

// 取消取件订单
export function pickup_cancel(code)
{
  return http.post('ups/pickup/cancel', { code })
}

// 取件价格
export function pickup_money(data)
{
  return http.post('api/ups/pickup/money', data)
}

// 取件地址搜索
export function pickup_address(name)
{
  return http.post('user/ups_pickup_addres', {
    name
  })
}


// 地址搜索
export function address(name, type)
{
  return http.post('user/ups_addres', {
    name,
    type
  })
}

// 我的订单
export function user_order(page, where)
{
  return http.get('user/ups_order?page=' + page, {
    params: where
  })
}

// 我的取件订单
export function user_pickup(page, where)
{
  return http.get('user/ups_pickup?page=' + page, {
    params: where
  })
}
